module.exports = __webpack_public_path__ + "img/phone_2.b075a621.png";